/*
 * Get any applications that the current user has access to (with role data)
 */
import type { RootState } from '/business/shared/state/store';
import { EMPTY_ARRAY } from '/business/shared/state/selectors/util';

export default (state: RootState) => state.applications?.items || EMPTY_ARRAY;
